import type { ReactNode } from "react"

export function BaseLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen justify-center">
      <div className="flex min-h-screen w-full max-w-[400px] flex-col bg-card">{children}</div>
    </div>
  )
}
